import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate, formateDateWithMonth, getFormatedTime, handleServerValidations } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import { subscribeForPremium, subscriptionHistoryList, unsubscribeFromPremium, userDetails, UserChatHistoryList } from "../../services/user.service";
import Swal from "sweetalert2";
import { SUBSCRIPTION_NAMES, SUBSCRIPTION_PRODUCT_IDS, SWAL_SETTINGS } from "../../../../utils/Constants";
import { SubscriptionHistoryList } from "../../services/subscriptionPlan.services";
import CustomRangepicker from "../../common/rangepicker";
import CustomPagination from "../../common/custompagination";
    
const ViewUserChatHistory = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();
    const [searchParams] = useSearchParams();

    const [showdefault, setShowDefault] = useState({});
    const [statsupdate, setStatusUpdate] = useState("false");
    const [chatHistoryList, setChatHistoryList] = useState([]);
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const [loader, setLoader] = useState(true);
    const [resetdate, setResetDate] = useState(false);

    useEffect(() => {

        const getData = setTimeout(() => {
          if (search) {
            setLoader(true);
            const formData = new FormData();
            formData.append("_id", params.id);
            formData.append("year", searchParams.get('year'));
            formData.append("month", searchParams.get('month'));
            formData.append("page", 1);
            formData.append("per_page", itemperpage);
            formData.append("sort", JSON.stringify(sorting));
            formData.append("search", JSON.stringify(search));
            formData.append("global_search", globalsearch);
            UserChatHistoryList(formData)
              .then((data) => {
                setDataLength(data.data.total_records);
                setChatHistoryList(data && data.data && data.data.list ? data.data.list : []);
                setPage(data && data.data && data.data.page ? data.data.page : 1);
                setLoader(false);
              })
              .catch((error) => {
                 setLoader(false);
                console.log("error ====> ", error);
              });
          }
        }, 300);
        return () => clearTimeout(getData)
      }, [
        location,
        statsupdate,
        sorting,
        search,
        globalsearch,
        itemperpage,
        params.pgno,
    ]);


    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
        sort.order = -1;
        } else {
        sort.order = 1;
        }
        setSorting(sort);
    };
  // sorting end

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
        sr[key] = value;
        } else {
        delete sr[key];
        }
        setSearch(sr);
    };

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
        // $("#defaultstatus")[0].selectedIndex = 0;
    };

    // const viewfunction = (row) => {
    //     navigate(
    //         `/admin/user-management/user/view/user-details/${params.id}/${params.pgno}/chat-history/${params.activityPgno}`
    //     );
    // };

   return (
        <>
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">

                        <div className="card-body">
                            <div className="row">
                                <div className="animation_fade">
                                    <div className="card custom-card">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="form-group mb-0 me-3">
                                                        <div className="form-group mb-0 rangepicker_container filter_design">
                                                            <i className="fa fa-search calender_icon"></i>
                                                            <input
                                                                type="search"
                                                                className="form-control"
                                                                value={globalsearch}
                                                                placeholder={t("input_placeholder_search")}
                                                                onChange={(e) => {
                                                                    setGlobalSearch(e.target.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="me-3">
                                                        <CustomRangepicker
                                                            GetDateRange={(e) => {
                                                            prepareSearch("createdAt", e);
                                                            }}
                                                            resetdate={resetdate}
                                                        />
                                                    </div>
                                                    
                                                    <button
                                                        type="reset"
                                                        value="Reset"
                                                        onClick={resetFilter}
                                                        className="btn btn-warning float-right mr-2"
                                                    >
                                                        {t("btn_reset_filter")}
                                                    </button>
                                                    
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                                    <thead>
                                                        <tr>
                                                            <th className="position-relative select_head">
                                                                <span>{t("User Query")}</span>
                                                            </th>

                                                            <th className="position-relative select_head">
                                                                <span>{t("Chatbot response")}</span>
                                                            </th>      

                                                            <th className="position-relative select_head">
                                                                <span>{t("Created At")}</span>
                                                            </th>
                                                            
                                                            {/* <th className="action_head">{t("list_heading_action")}</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loader ? (
                                                            <tr>
                                                            <td colSpan={14}>
                                                                <Loader />
                                                            </td>
                                                            </tr>
                                                        ) : (
                                                            <>
                                                            {chatHistoryList.length ? (
                                                                chatHistoryList.map((row, i) => {
                                                                return (
                                                                    <tr
                                                                    key={i}
                                                                    >
                                                                        <td>
                                                                            {row?.user_query || "N/A"}
                                                                        </td>
                                                                        <td>
                                                                            {row?.chatbot_response || "N/A"}
                                                                        </td>
                                                                        <td>
                                                                            {formateDate(row?.createdAt) || "N/A"}
                                                                        </td>

                                                                        {/* <td>
                                                                            <div className="d-flex">
                                                                            <button
                                                                                className="btn ripple btn-main-primary signbtn"
                                                                                onClick={() => {
                                                                                    viewfunction(row);
                                                                                }}
                                                                            >
                                                                                View 
                                                                            </button>

                                                                            </div>
                                                                        </td> */}

                                                                    </tr>
                                                                );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                <td colSpan={14} className="text-center">
                                                                    {t("msg_no_records")}
                                                                </td>
                                                                </tr>
                                                            )}
                                                            </>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        
                                            <div
                                                className=""
                                                id="example1_info"
                                                role="status"
                                                aria-live="polite"
                                            >
                                                <b>
                                                    {t("msg_total_records")} : {datalength ? datalength : "0"}
                                                </b>
                                            </div>

                                            {datalength && datalength > 0 ? (
                                                <CustomPagination
                                                    datalength={datalength}
                                                    itemperpage={itemperpage}
                                                    currentPage={page}
                                                    setPage={setPage}
                                                    pageRoute={[
                                                    {
                                                        name: "Psychic",
                                                        path: `/admin/user-management/user/view/${params.id}`,
                                                    },
                                                    ]}
                                                />
                                                ) : (
                                                ""
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Back Button */}
                        <div className="mt-2 back-button">
                            <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                {t("btn_back")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewUserChatHistory;
